import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Button,
  Chip,
  Divider,
} from "@mui/material";
import {
  Star,
  Hotel,
  DirectionsCar,
  Restaurant,
  Hiking,
  AccessTime,
} from "@mui/icons-material";
import { motion } from "framer-motion";

const enrichTour = (tour, index) => {
  const durations = ["5 Days / 4 Nights", "6 Days / 5 Nights", "7 Days / 6 Nights"];
  const tags = ["Group Tour", "Bestseller", "Limited Seats"];

  const basePrice = parseInt(tour.price.replace(/[₹,/-]/g, ""));

  return {
    ...tour,
    duration: durations[index % durations.length],
    tag: tags[index % tags.length],
    oldPrice: basePrice + 5000,
    discountEndsIn: "Hurry! Ends Soon",
  };
};

const TourCard = ({ tour, index, onViewDetails, onEnquire }) => {
  const t = enrichTour(tour, index);

    return (

    <motion.div
      whileHover={{ y: -6 }}
      transition={{ duration: 0.3 }}
    >
      <Card
        sx={{
          borderRadius: 4,
          overflow: "hidden",
          boxShadow: "0 18px 40px rgba(0,0,0,0.15)",
          backgroundColor: "#fff",
        }}
      >
        {/* IMAGE */}
        <Box sx={{ position: "relative" }}>
          <CardMedia component="img" height="230" image={t.image} />

          {/* Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(to top, rgba(0,0,0,0.65), rgba(0,0,0,0.15), transparent)",
            }}
          />

          {/* Tag */}
          <Chip
            label={t.tag}
            size="small"
            sx={{
              position: "absolute",
              top: 14,
              left: 14,
              bgcolor: "#0f766e",
              color: "#fff",
              fontWeight: 700,
              letterSpacing: 0.3,
            }}
          />

          {/* Duration */}
          <Box
            sx={{
              position: "absolute",
              bottom: 14,
              left: 14,
              display: "flex",
              alignItems: "center",
              color: "#fff",
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            <AccessTime sx={{ fontSize: 16, mr: 0.5 }} />
            {t.duration}
          </Box>
        </Box>

        {/* CONTENT */}
        <CardContent sx={{ p: 2.5 }}>
          {/* Title */}
          <Typography
            fontWeight={800}
            fontSize="1.15rem"
            sx={{ lineHeight: 1.3 }}
          >
            {t.title}
          </Typography>

          {/* Rating */}
          <Box sx={{ display: "flex", alignItems: "center", mt: 0.6 }}>
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                sx={{
                  fontSize: 17,
                  color: i < Math.round(t.rating) ? "#fbbf24" : "#e5e7eb",
                }}
              />
            ))}
            <Typography sx={{ ml: 0.8, fontSize: 13, color: "#555" }}>
              {t.rating} / 5
            </Typography>
          </Box>

          {/* Places */}
          <Typography
            sx={{
              fontSize: 13.5,
              color: "#6b7280",
              mt: 1,
              height: 40,
              overflow: "hidden",
            }}
          >
            {t.places}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Inclusions */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              color: "#374151",
              mb: 1.5,
            }}
          >
            <Hotel />
            <DirectionsCar />
            <Restaurant />
            <Hiking />
          </Box>

          {/* Price */}
          <Box sx={{ mb: 1 }}>
            <Typography
              sx={{
                fontSize: 13,
                color: "#9ca3af",
                textDecoration: "line-through",
              }}
            >
              ₹ {t.oldPrice.toLocaleString()}
            </Typography>

            <Typography
              sx={{
                fontSize: "1.4rem",
                fontWeight: 900,
                color: "#0f766e",
              }}
            >
              {t.price}
            </Typography>

            <Typography
              sx={{
                fontSize: 12,
                color: "#6b7280",
              }}
            >
              per person
            </Typography>
          </Box>

          {/* Offer */}
          <Box
            sx={{
              background: "#ecfeff",
              color: "#155e75",
              fontSize: 12.5,
              fontWeight: 700,
              py: 0.8,
              borderRadius: 1,
              textAlign: "center",
              mb: 2,
            }}
          >
            {t.discountEndsIn}
          </Box>

          {/* CTA */}
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={()=>{
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  onViewDetails()}}
              sx={{
                borderRadius: 2,
                fontWeight: 700,
                borderColor: "#0f766e",
                color: "#0f766e",
              }}
            >
            View Details    
           </Button>

            <Button
              fullWidth
              variant="contained"
              onClick={()=>{
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  onEnquire();
              }}
              sx={{
                borderRadius: 2,
                fontWeight: 800,
                background:
                  "linear-gradient(135deg, #0f766e, #065F46)",
              }}
            >
              Enquire Now
            </Button>
          </Box>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default TourCard;